import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCompanyListStart } from "../../../Store/Slices/organizationSlice";
import { getModuleByIdStart } from "../../../Store/Slices/formSlice";
import { Dropdown, Modal } from "react-bootstrap";

const AnnexureContent = ({
    showQTAnnexureContent,
    setshowQTAnnexureContent,
    QTAnnexureValues,
    handleInsertQTAnnexurePlaceholder,
    handleQTAnnexureValuesChange
}) => {
    const dispatch = useDispatch();
    let currentOrg = useSelector((state) => state?.org)?.companyData?.[0];
    let navbarList = useSelector((state) => state?.forms)?.navbarList;
    let formList = useSelector((state) => state?.forms)?.modules;
    let currentUser = useSelector((state) => state?.user)?.allUserData?.[0];
    let [annexurePlaceholders, setAnnexurePlaceholders] = useState([])
    let [fieldList, setFieldList] = useState([]);

    const formatText = (text) => {
        return text
            .replace(/_/g, ' ')                  // Replace underscores with spaces
            .replace(/([a-z])([A-Z])/g, '$1 $2') // Add space before capital letters
            .replace(/^./, str => str.toUpperCase()); // Capitalize first letter
    }

    useEffect(() => {
        dispatch(getCompanyListStart());
    }, [])

    useEffect(() => {
        if (currentOrg) {
            let fields = Object.keys(currentOrg)
                .filter(item =>
                    item !== '__v' && item !== '_id' && item !== 'createdBy' && item !== 'isActive' &&
                    item !== 'access_url' && item !== 'createdAt' && item !== 'updatedAt'
                ).map(data => ({ key: data, value: formatText(data) }))
            if (fields) {
                let newItem = {
                    categoryTitle: 'ORGANIZATION',
                    items: fields
                }
                // console.log('placeholder:', fields)
                setAnnexurePlaceholders(prevItems => {
                    const exists = prevItems.some(item => item.categoryTitle === 'ORGANIZATION');
                    if (!exists) {
                        return [...prevItems, newItem];
                    }
                    return prevItems;
                });
            }
        }
    }, [currentOrg])

    useEffect(() => {
        if (currentUser) {
            let fields = Object.keys(currentUser)
                .filter(item =>
                    item !== '__v' && item !== '_id' && item !== 'Profile' && item !== 'role' &&
                    item !== 'access_url' && item !== 'createdAt' && item !== 'updatedAt'
                    && item !== 'createdBy' && item !== 'isActive' && item !== 'isVerified'
                    && item !== 'is_company' && item !== 'is_email_verified' && item !== 'is_password'
                    && item !== 'is_social_login' && item !== 'login_type' && item !== 'password'
                    && item !== 'verification_code'
                ).map(data => ({ key: data, value: formatText(data) }))
            if (fields) {
                let newItem = {
                    categoryTitle: 'CUSTOMER',
                    items: fields
                }
                setAnnexurePlaceholders(prevItems => {
                    const exists = prevItems.some(item => item.categoryTitle === 'CUSTOMER');
                    if (!exists) {
                        return [...prevItems, newItem];
                    }
                    return prevItems;
                });
            }
        }
    }, [currentUser])

    useEffect(() => {
        if (navbarList?.length) {
            let id = navbarList?.filter(item => item.name === 'Quotes')?.[0]?._id
            if (id) {
                dispatch(getModuleByIdStart(id));
            }
        }
    }, [navbarList])

    useEffect(() => {
        if (formList?.length > 0) {
            setFieldList([]);
            let sections = formList?.[0]?.fields?.sections;
            // console.log('sections:', sections)
            for (var i = 0; i < sections.length; i++) {
                if (sections[i].dropped_list) {
                    let list = sections[i].dropped_list
                    // console.log('dropped list:', list)
                    let o_val = Object.values(list)
                    for (var j = 0; j < o_val.length; j++) {
                        for (var k = 0; k < o_val[j].length; k++) {
                            let _value = o_val[j][k];
                            setFieldList(list => [...list, _value])
                        }
                    }
                }
            }
        }
    }, [formList])

    useEffect(() => {
        if (fieldList?.length > 0) {
            let fields = fieldList
                .map(data => ({ key: data.extra_fields.field_label, value: data.extra_fields.field_label }))
            if (fields) {
                let newItem = {
                    categoryTitle: 'QUOTES',
                    items: fields
                }
                setAnnexurePlaceholders(prevItems => {
                    const exists = prevItems.some(item => item.categoryTitle === 'QUOTES');
                    if (!exists) {
                        return [...prevItems, newItem];
                    }
                    return prevItems;
                });
            }
        }
    }, [fieldList])

    return (
        <Modal
            show={showQTAnnexureContent}
            onHide={() => setshowQTAnnexureContent(false)}
            backdrop="static"
            keyboard={false}
            size="lg"
        >
            <Modal.Header closeButton>
                <Modal.Title className="font-17 fw-normal">
                    <span className="align-middle">Customize your annexure content</span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="card p-0">
                    <div className="card-header d-flex justify-content-between">
                        <Dropdown>
                            <Dropdown.Toggle variant="light" className="with-arrow px-3" id="headFootCont_dropdownBtn">
                                <span className="pe-3">Insert Placeholders</span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="max-h-400px">
                                <div className="hstack align-items-start">
                                    {annexurePlaceholders.length > 0 && annexurePlaceholders.map((categoryTitle, index) => (
                                        <div key={index} className={index !== 0 ? 'ps-2 border-start' : 'pe-2'}>
                                            <Dropdown.ItemText className="fw-medium dropdown-header">{categoryTitle.categoryTitle}</Dropdown.ItemText>
                                            {categoryTitle.items.map((item, itemIndex) => (
                                                <Dropdown.Item key={itemIndex} onClick={() => handleInsertQTAnnexurePlaceholder(categoryTitle.categoryTitle, item.value)}>
                                                    {item.value}
                                                </Dropdown.Item>
                                            ))}
                                        </div>
                                    ))}
                                </div>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                    <textarea rows={9} id="header_custom_cont_input" className="form-control border-0"
                        value={QTAnnexureValues} onChange={handleQTAnnexureValuesChange}></textarea>
                </div>
                <div className="mt-4 form-text text-muted d-none">
                    <span className="fw-semibold pe-2">Note:</span>
                    If your content exceeds the template margin, you can adjust the margin values accordingly.
                </div>
            </Modal.Body>
        </Modal>
    )
}
export default AnnexureContent;